export const homeFor = (role) => (role === "admin" ? "/admin" : role === "cliente" ? "/cliente" : "/partner");
